import axios from "axios";
import { getToken } from "../session";

const PUT = async (endpoint, data) => {
  const response = await axios.put(endpoint, data, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  });
  return response;
};

export default PUT;
